/* src/app/europe-access-document/europe-access-document.component.scss */
/*# sourceMappingURL=europe-access-document.component-LZIZY5E3.css.map */
